(function () {
  'use strict';

  if (window.__cartSubscriptionUpgradeInit) return;
  window.__cartSubscriptionUpgradeInit = true;

  function getCartChangeUrl() {
    return window.routes?.cart_change_url || '/cart/change.js';
  }

  function getRequestConfig() {
    if (typeof fetchConfig === 'function') {
      return fetchConfig('json');
    }

    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };
  }

  function getSectionsForRequest(container) {
    const inDrawer = Boolean(container?.closest('cart-drawer-items'));

    if (inDrawer) {
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    const sections = [];
    const cartItems = document.getElementById('main-cart-items');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartItems?.dataset.id) sections.push(cartItems.dataset.id);
    if (cartFooter?.dataset.id) sections.push(cartFooter.dataset.id);
    sections.push('cart-icon-bubble', 'cart-live-region-text');

    // Keep drawer in sync when changing plans from the cart page.
    if (document.querySelector('cart-drawer-items')) {
      sections.push('cart-drawer');
    }

    return sections.filter(Boolean);
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  function updateSectionElements(parsedState, sections) {
    sections.forEach((section) => {
      const sectionHtml = parsedState.sections?.[section.section];
      if (!sectionHtml) return;

      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      if (!elementToReplace) return;

      const html = getSectionInnerHTML(sectionHtml, section.selector);
      if (html != null) elementToReplace.innerHTML = html;
    });
  }

  function syncEmptyState(parsedState) {
    const isEmpty = parsedState.item_count === 0;
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', isEmpty);
    document.querySelector('cart-drawer-items')?.classList.toggle('is-empty', isEmpty);
    document.querySelector('cart-items')?.classList.toggle('is-empty', isEmpty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
  }

  function captureCartScrollPosition(container) {
    const drawerItems = document.querySelector('cart-drawer-items');
    const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    const mainCart = document.getElementById('main-cart-items');
    const lineItem = container?.closest('[data-line-item-key]');
    const lineIndex =
      lineItem?.querySelector('[name="updates[]"]')?.dataset?.index ||
      lineItem?.querySelector('[data-index]')?.dataset?.index ||
      null;

    return {
      drawerItemsScroll: drawerItems?.scrollTop ?? null,
      drawerInnerScroll: drawerInner?.scrollTop ?? null,
      mainCartScroll: mainCart?.scrollTop ?? null,
      windowScrollY: window.scrollY,
      lineIndex,
      inDrawer: Boolean(container?.closest('cart-drawer-items')),
    };
  }

  function focusLineWithoutScroll(lineIndex) {
    if (!lineIndex) return;

    const lineItem =
      document.getElementById(`CartDrawer-Item-${lineIndex}`) ||
      document.getElementById(`CartItem-${lineIndex}`);
    if (!lineItem) return;

    const focusTarget =
      lineItem.querySelector(
        '[data-cart-subscription-dropdown]:not([hidden]) [data-cart-subscription-trigger]'
      ) ||
      lineItem.querySelector(
        '[data-cart-subscription-upgrade]:not([hidden]) [data-cart-subscription-upgrade-btn]'
      ) ||
      lineItem.querySelector('[data-cart-subscription-trigger]') ||
      lineItem.querySelector('[data-cart-subscription-upgrade-btn]');

    if (!focusTarget || typeof focusTarget.focus !== 'function') return;

    try {
      focusTarget.focus({ preventScroll: true });
    } catch (error) {
      focusTarget.focus();
    }
  }

  function restoreCartScrollPosition(scrollState) {
    if (!scrollState) return;

    const apply = () => {
      const drawerItems = document.querySelector('cart-drawer-items');
      const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
      const mainCart = document.getElementById('main-cart-items');

      if (drawerItems && scrollState.drawerItemsScroll != null) {
        drawerItems.scrollTop = scrollState.drawerItemsScroll;
      }
      if (drawerInner && scrollState.drawerInnerScroll != null) {
        drawerInner.scrollTop = scrollState.drawerInnerScroll;
      }
      if (mainCart && scrollState.mainCartScroll != null) {
        mainCart.scrollTop = scrollState.mainCartScroll;
      }
      if (!scrollState.inDrawer && scrollState.windowScrollY != null) {
        window.scrollTo(0, scrollState.windowScrollY);
      }

      focusLineWithoutScroll(scrollState.lineIndex);
    };

    apply();
    requestAnimationFrame(() => {
      apply();
      requestAnimationFrame(apply);
    });
  }

  function renderUpdatedSections(parsedState, container) {
    const scrollState = captureCartScrollPosition(container);
    const inDrawer = Boolean(container?.closest('cart-drawer-items'));
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    const cartItems = document.querySelector('cart-items:not(cart-drawer-items)');
    const hadVisibleNotice = Boolean(
      document.querySelector('.shipping-notice.loaded')
    );

    if (inDrawer && cartDrawerItems?.getSectionsToRender) {
      updateSectionElements(parsedState, cartDrawerItems.getSectionsToRender());
      syncEmptyState(parsedState);
      syncShippingNotice(parsedState, hadVisibleNotice);

      // source: cart-items prevents CartItems/CartDrawerItems from re-fetching
      // and overwriting the sections we just rendered.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cart: parsedState,
        });
      }
      restoreCartScrollPosition(scrollState);
      return;
    }

    if (cartItems?.getSectionsToRender) {
      try {
        updateSectionElements(parsedState, cartItems.getSectionsToRender());
      } catch (error) {
        console.error(error);
      }
    }

    if (cartDrawerItems?.getSectionsToRender && parsedState.sections?.['cart-drawer']) {
      updateSectionElements(parsedState, cartDrawerItems.getSectionsToRender());
    }

    syncEmptyState(parsedState);
    syncShippingNotice(parsedState, hadVisibleNotice);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-items',
        cart: parsedState,
      });
    }
    restoreCartScrollPosition(scrollState);
  }

  function syncShippingNotice(parsedState, hadVisibleNotice = false) {
    if (!window.shippingThreshold) return;

    window.shippingThreshold.markNoticesReady(document, {
      keepVisible: hadVisibleNotice,
    });
    window.shippingThreshold.sync({
      cartTotalCents: parsedState?.total_price,
      animate: !hadVisibleNotice,
      preferNetwork: parsedState?.total_price == null,
    });
  }

  function applyExpandedStates(root) {
    const scope = root || document;

    scope.querySelectorAll('[data-cart-subscription]').forEach((container) => {
      const hasPlan = container.dataset.hasSellingPlan === 'true';
      const upgrade = container.querySelector('[data-cart-subscription-upgrade]');
      const dropdown = container.querySelector('[data-cart-subscription-dropdown]');

      if (hasPlan) {
        upgrade?.setAttribute('hidden', '');
        dropdown?.removeAttribute('hidden');
      } else {
        upgrade?.removeAttribute('hidden');
        dropdown?.setAttribute('hidden', '');
        closeDropdown(dropdown);
      }

      syncDropdownLabel(container);
    });
  }

  function showUpgradeUI(container) {
    const upgrade = container.querySelector('[data-cart-subscription-upgrade]');
    const dropdown = container.querySelector('[data-cart-subscription-dropdown]');

    upgrade?.removeAttribute('hidden');
    dropdown?.setAttribute('hidden', '');
    closeDropdown(dropdown);
  }

  function showDropdownUI(container) {
    const upgrade = container.querySelector('[data-cart-subscription-upgrade]');
    const dropdown = container.querySelector('[data-cart-subscription-dropdown]');

    upgrade?.setAttribute('hidden', '');
    dropdown?.removeAttribute('hidden');
  }

  function syncDropdownLabel(container) {
    const labelEl = container.querySelector('[data-cart-subscription-label]');
    if (!labelEl) return;

    const currentPlanId = container.dataset.currentPlanId || '';
    const option =
      container.querySelector(
        `[data-cart-subscription-option][data-plan-id="${currentPlanId}"]`
      ) ||
      container.querySelector('[data-cart-subscription-option][data-plan-id=""]');

    if (option) {
      labelEl.textContent = option.dataset.planLabel || option.textContent.trim();
    } else if (container.dataset.currentPlanLabel) {
      labelEl.textContent = container.dataset.currentPlanLabel;
    }

    container.querySelectorAll('[data-cart-subscription-option]').forEach((el) => {
      el.setAttribute(
        'aria-selected',
        el.dataset.planId === currentPlanId ? 'true' : 'false'
      );
    });
  }

  function resetDropdownPanelPosition(panel) {
    if (!panel) return;

    panel.style.position = '';
    panel.style.top = '';
    panel.style.left = '';
    panel.style.width = '';
    panel.style.maxWidth = '';
    panel.style.right = '';
    panel.style.zIndex = '';
    panel.classList.remove('is-fixed');
  }

  function getDropdownPanel(dropdown) {
    if (!dropdown) return null;
    return (
      dropdown._cartSubPanel ||
      dropdown.querySelector('[data-cart-subscription-panel]') ||
      document.querySelector(
        `[data-cart-subscription-panel][data-line-key="${dropdown.closest('[data-cart-subscription]')?.dataset.lineKey || ''}"]`
      )
    );
  }

  // Screen readers ignore content outside an open aria-modal dialog, so inside
  // the cart drawer the panel must stay within the dialog element.
  function getPanelHost(dropdown) {
    return dropdown.closest('[role="dialog"][aria-modal="true"]') || document.body;
  }

  function mountPanelToBody(dropdown) {
    const panel = getDropdownPanel(dropdown);
    if (!panel) return null;

    const container = dropdown.closest('[data-cart-subscription]');
    if (container?.dataset.lineKey) {
      panel.dataset.lineKey = container.dataset.lineKey;
    }

    dropdown._cartSubPanel = panel;
    panel._cartSubDropdown = dropdown;

    // Escape drawer overflow/filter clipping so the menu is visible.
    const host = getPanelHost(dropdown);
    if (panel.parentElement !== host) {
      host.appendChild(panel);
    }

    return panel;
  }

  function restorePanel(dropdown) {
    const panel = getDropdownPanel(dropdown);
    if (!panel) return null;

    panel.setAttribute('hidden', '');
    resetDropdownPanelPosition(panel);

    if (panel.parentElement !== dropdown && dropdown.isConnected) {
      dropdown.appendChild(panel);
    }

    return panel;
  }

  function positionDropdownPanel(dropdown) {
    const trigger = dropdown.querySelector('[data-cart-subscription-trigger]');
    const panel = getDropdownPanel(dropdown);
    if (!trigger || !panel) return;

    const rect = trigger.getBoundingClientRect();
    const viewportPad = 8;

    // A transformed/filtered host (the drawer dialog) becomes the containing
    // block for position: fixed and clips overflow, so measure against it.
    const host = panel.parentElement;
    const hostRect =
      host && host !== document.body ? host.getBoundingClientRect() : null;
    const bounds = hostRect
      ? {
          left: hostRect.left,
          right: hostRect.right,
          top: hostRect.top,
          bottom: Math.min(hostRect.bottom, window.innerHeight),
        }
      : { left: 0, right: window.innerWidth, top: 0, bottom: window.innerHeight };

    const minLeft = bounds.left + viewportPad;
    const maxRight = bounds.right - viewportPad;
    const maxWidth = Math.max(0, maxRight - minLeft);
    let width = Math.min(Math.round(rect.width), maxWidth);
    let left = Math.round(rect.left);

    // Keep the portaled panel fully on-screen (narrow phones / drawer edge).
    if (left + width > maxRight) {
      left = Math.max(minLeft, maxRight - width);
    }
    if (left < minLeft) {
      left = minLeft;
      width = Math.min(width, maxWidth);
    }

    const panelHeight = panel.offsetHeight || 0;
    let top = Math.round(rect.bottom - 1);

    if (top + panelHeight > bounds.bottom - viewportPad) {
      top = Math.max(
        bounds.top + viewportPad,
        Math.round(rect.top - panelHeight + 1)
      );
    }

    if (hostRect) {
      left = left - hostRect.left - host.clientLeft + host.scrollLeft;
      top = top - hostRect.top - host.clientTop + host.scrollTop;
    }

    panel.style.position = 'fixed';
    panel.style.top = `${top}px`;
    panel.style.left = `${left}px`;
    panel.style.width = `${width}px`;
    panel.style.right = 'auto';
    panel.style.maxWidth = `${maxWidth}px`;
    // Above cart drawer (theme uses an extremely high drawer z-index).
    panel.style.zIndex = '1000000000000';
    panel.classList.add('is-fixed');
  }

  function repositionOpenDropdowns() {
    document
      .querySelectorAll('[data-cart-subscription-dropdown].is-open')
      .forEach((dropdown) => positionDropdownPanel(dropdown));
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;

    dropdown.classList.remove('is-open');
    const trigger = dropdown.querySelector('[data-cart-subscription-trigger]');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.removeAttribute('aria-activedescendant');
    getDropdownPanel(dropdown)
      ?.querySelectorAll('[data-cart-subscription-option].is-active')
      .forEach((option) => option.classList.remove('is-active'));
    restorePanel(dropdown);

    dropdown
      .closest('[data-line-item-key]')
      ?.classList.remove('cart-line-item--dropdown-open');
  }

  function closeAllDropdowns(except) {
    document.querySelectorAll('[data-cart-subscription-dropdown]').forEach((dropdown) => {
      if (except && dropdown === except) return;
      closeDropdown(dropdown);
    });
  }

  function openDropdown(dropdown) {
    if (!dropdown) return;

    closeAllDropdowns(dropdown);
    dropdown.classList.add('is-open');
    dropdown
      .querySelector('[data-cart-subscription-trigger]')
      ?.setAttribute('aria-expanded', 'true');

    const panel = mountPanelToBody(dropdown);
    panel?.removeAttribute('hidden');
    positionDropdownPanel(dropdown);
    // Reposition after paint so max-height / content size is known.
    requestAnimationFrame(() => positionDropdownPanel(dropdown));

    dropdown
      .closest('[data-line-item-key]')
      ?.classList.add('cart-line-item--dropdown-open');
  }

  function getEnabledOptions(dropdown) {
    const panel = getDropdownPanel(dropdown);
    if (!panel) return [];
    return Array.from(
      panel.querySelectorAll('[data-cart-subscription-option]:not([disabled])')
    );
  }

  function setActiveOption(dropdown, option) {
    const trigger = dropdown.querySelector('[data-cart-subscription-trigger]');
    getEnabledOptions(dropdown).forEach((el) =>
      el.classList.toggle('is-active', el === option)
    );
    if (!trigger || !option) return;
    trigger.setAttribute('aria-activedescendant', option.id);
    option.scrollIntoView({ block: 'nearest' });
  }

  let suppressEscapeKeyup = false;
  let suppressSpaceKeyup = false;

  function handleTriggerKeydown(event) {
    const trigger = event.target.closest?.('[data-cart-subscription-trigger]');
    if (!trigger || trigger.disabled) return;
    const dropdown = trigger.closest('[data-cart-subscription-dropdown]');
    if (!dropdown) return;

    const isOpen = dropdown.classList.contains('is-open');
    const options = getEnabledOptions(dropdown);
    const activeIndex = options.findIndex((option) =>
      option.classList.contains('is-active')
    );
    const selectedIndex = options.findIndex(
      (option) => option.getAttribute('aria-selected') === 'true'
    );

    const openWithActive = (index) => {
      openDropdown(dropdown);
      setActiveOption(dropdown, options[index >= 0 ? index : 0]);
    };

    switch (event.key) {
      case 'ArrowDown':
      case 'ArrowUp': {
        event.preventDefault();
        if (!isOpen) {
          openWithActive(selectedIndex);
          return;
        }
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const start = activeIndex >= 0 ? activeIndex : selectedIndex;
        const next = Math.min(
          options.length - 1,
          Math.max(0, (start >= 0 ? start : -1) + step)
        );
        setActiveOption(dropdown, options[next]);
        break;
      }
      case 'Home':
      case 'End':
        if (!isOpen) return;
        event.preventDefault();
        setActiveOption(
          dropdown,
          options[event.key === 'Home' ? 0 : options.length - 1]
        );
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        if (event.key === ' ') suppressSpaceKeyup = true;
        if (isOpen && activeIndex >= 0) {
          options[activeIndex].click();
        } else if (isOpen) {
          closeDropdown(dropdown);
        } else {
          openWithActive(selectedIndex);
        }
        break;
      case 'Escape':
        if (!isOpen) return;
        event.preventDefault();
        event.stopPropagation();
        suppressEscapeKeyup = true;
        closeDropdown(dropdown);
        break;
      case 'Tab':
        if (isOpen) closeDropdown(dropdown);
        break;
      default:
        break;
    }
  }

  function handleTriggerKeyup(event) {
    if (event.key === 'Escape' && suppressEscapeKeyup) {
      suppressEscapeKeyup = false;
      event.stopPropagation();
    }
    if (event.key === ' ' && suppressSpaceKeyup) {
      suppressSpaceKeyup = false;
      event.preventDefault();
    }
  }

  function findDropdownFromEventTarget(target) {
    const triggerDropdown = target.closest?.('[data-cart-subscription-dropdown]');
    if (triggerDropdown) return triggerDropdown;

    const panel = target.closest?.('[data-cart-subscription-panel]');
    return panel?._cartSubDropdown || null;
  }

  function clearError(container) {
    const errorEl = container.querySelector('[data-cart-subscription-error]');
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.setAttribute('hidden', '');
  }

  function showError(container, message) {
    const errorEl = container.querySelector('[data-cart-subscription-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.removeAttribute('hidden');
  }

  function getLineItemData(container) {
    const lineItem = container.closest('[data-line-item-key]');
    const key = lineItem?.dataset.lineItemKey || container.dataset.lineKey;
    const qtyInput =
      lineItem?.querySelector('input[name="updates[]"]') ||
      container.closest('.cart-item')?.querySelector('input[name="updates[]"]');
    const quantity = qtyInput
      ? parseInt(qtyInput.value, 10)
      : parseInt(container.dataset.quantity, 10);
    const line = qtyInput?.dataset.index
      ? parseInt(qtyInput.dataset.index, 10)
      : null;

    return { lineItem, key, quantity, line };
  }

  function setBusy(container, busy) {
    container.classList.toggle('cart-subscription--busy', busy);
    container.querySelectorAll('button').forEach((el) => {
      el.disabled = busy;
    });
  }

  async function resolveFirstPlanId(container) {
    const fromButton = container.dataset.firstPlanId;
    if (fromButton) return fromButton;

    const handle = container.dataset.productHandle;
    const variantId = Number(container.dataset.variantId);
    if (!handle || !variantId) return null;

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;

      const product = await response.json();
      const variant = product.variants.find((entry) => entry.id === variantId);
      const allocation = variant?.selling_plan_allocations?.[0];

      return allocation?.selling_plan_id
        ? String(allocation.selling_plan_id)
        : null;
    } catch (error) {
      console.error('Cart subscription: unable to load selling plans', error);
      return null;
    }
  }

  async function changeLineItemSellingPlan(container, sellingPlanId) {
    const { key, quantity, line } = getLineItemData(container);
    if ((!line && !key) || Number.isNaN(quantity)) return;

    const currentPlanId = container.dataset.currentPlanId || '';
    const nextPlanId = sellingPlanId ? String(sellingPlanId) : '';

    if (currentPlanId === nextPlanId) return;

    clearError(container);
    setBusy(container, true);
    closeAllDropdowns();

    // Capture before the network round-trip so scroll stays where the user was.
    const scrollState = captureCartScrollPosition(container);

    // Selling plan updates require `line` per Shopify Ajax Cart API.
    const body = {
      quantity,
      selling_plan: nextPlanId || null,
      sections: getSectionsForRequest(container),
      sections_url: window.location.pathname,
    };

    if (line) {
      body.line = line;
    } else {
      body.id = key;
    }

    try {
      const response = await fetch(getCartChangeUrl(), {
        ...getRequestConfig(),
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (data.status || data.errors) {
        applyExpandedStates(container.closest('cart-drawer-items, cart-items') || document);
        showError(
          container,
          data.message || data.description || window.cartStrings?.error || 'Cart update failed'
        );
        return;
      }

      renderUpdatedSections(data, container);
      requestAnimationFrame(() => {
        applyExpandedStates();
        restoreCartScrollPosition(scrollState);
      });
    } catch (error) {
      console.error(error);
      applyExpandedStates(container.closest('cart-drawer-items, cart-items') || document);
      showError(container, window.cartStrings?.error || 'Cart update failed');
    } finally {
      setBusy(container, false);
    }
  }

  async function handleUpgrade(container, button) {
    const planId =
      button.dataset.firstPlanId ||
      container.dataset.firstPlanId ||
      (await resolveFirstPlanId(container));

    if (!planId) {
      showError(container, 'No subscription plan available for this item.');
      return;
    }

    showDropdownUI(container);
    await changeLineItemSellingPlan(container, planId);
  }

  function handleDocumentClick(event) {
    const upgradeButton = event.target.closest('[data-cart-subscription-upgrade-btn]');
    if (upgradeButton && !upgradeButton.disabled) {
      event.preventDefault();
      event.stopPropagation();

      const container = upgradeButton.closest('[data-cart-subscription]');
      if (!container) return;

      handleUpgrade(container, upgradeButton);
      return;
    }

    const trigger = event.target.closest('[data-cart-subscription-trigger]');
    if (trigger && !trigger.disabled) {
      event.preventDefault();
      event.stopPropagation();

      const dropdown = trigger.closest('[data-cart-subscription-dropdown]');
      if (!dropdown) return;

      if (dropdown.classList.contains('is-open')) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
      return;
    }

    const option = event.target.closest('[data-cart-subscription-option]');
    if (option && !option.disabled) {
      event.preventDefault();
      event.stopPropagation();

      const panel = option.closest('[data-cart-subscription-panel]');
      const dropdown =
        panel?._cartSubDropdown ||
        document.querySelector('[data-cart-subscription-dropdown].is-open');
      const container =
        dropdown?.closest('[data-cart-subscription]') ||
        document.querySelector(
          `[data-cart-subscription][data-line-key="${panel?.dataset.lineKey || ''}"]`
        );

      if (!container) return;

      closeDropdown(dropdown);

      if (!option.dataset.planId) {
        showUpgradeUI(container);
      }

      changeLineItemSellingPlan(container, option.dataset.planId || null);
      return;
    }

    if (!findDropdownFromEventTarget(event.target)) {
      closeAllDropdowns();
    }
  }

  function init() {
    document.querySelectorAll('body > [data-cart-subscription-panel]').forEach((panel) => {
      const dropdown = panel._cartSubDropdown;
      if (!dropdown?.isConnected) {
        panel.remove();
        return;
      }
      restorePanel(dropdown);
    });
    closeAllDropdowns();
    applyExpandedStates();
  }

  document.addEventListener('click', handleDocumentClick, true);
  document.addEventListener('keydown', handleTriggerKeydown, true);
  document.addEventListener('keyup', handleTriggerKeyup, true);
  window.addEventListener('scroll', repositionOpenDropdowns, true);
  window.addEventListener('resize', repositionOpenDropdowns);

  document.addEventListener('DOMContentLoaded', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      requestAnimationFrame(init);
    });
  }

  if (typeof MutationObserver === 'function') {
    const startObserver = () => {
      if (!document.body) return;

      const containerAppeared = (node) =>
        node.nodeType === 1 &&
        (node.matches?.('[data-cart-subscription]') ||
          node.querySelector?.('[data-cart-subscription]'));

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (containerAppeared(node)) {
              applyExpandedStates();
              return;
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.body) {
      startObserver();
    } else {
      document.addEventListener('DOMContentLoaded', startObserver);
    }
  }
})();
